import React from 'react';
import { Button, Tag } from '@ver-uds/react';
import { Card, Icon } from '@ver-uds/uswds-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import './CaseAlertCard.scss';
import { EveRoutes } from '@ver-uds/e-verify';

interface Props {
  svg?: IconDefinition;
  count: number | undefined;
  title: string;
  buttonText: string;
  searchFilter: string;
  errorOccurred: boolean;
}

const tagCounter = (count: number): JSX.Element => {
  if (count >= 100) {
    return (
      <div className="margin-bottom-1 margin-top-1">
        <Tag variant="error">{count}</Tag>
      </div>
    );
  }
  if (count <= 99 && count >= 11) {
    return (
      <div className="margin-bottom-1 margin-top-1">
        <Tag variant="warning">{count}</Tag>
      </div>
    );
  }
  return (
    <div className="margin-bottom-1 margin-top-1">
      <Tag variant="success">{count}</Tag>
    </div>
  );
};

const CaseAlertCard = ({ svg, count, title, buttonText, searchFilter, errorOccurred }: Props): JSX.Element => {
  return (
    <div className="desktop-lg:grid-col desktop:grid-col-6 tablet:grid-col-6 mobile:grid-col-12">
      <Card className="case-alert-card">
        {svg && <FontAwesomeIcon icon={svg} />}
        <Card.Header as="h3">
          {errorOccurred && !count ? (
            <Icon className="error-outline" name="error_outline" />
          ) : (
            <> {count !== undefined && <>{tagCounter(count)}</>} </>
          )}
          {title}
        </Card.Header>
        <Card.Footer>
          <Button as="a" href={`${EveRoutes.CASES_VIEW}?filter=${searchFilter}`}>
            {buttonText}
          </Button>
        </Card.Footer>
      </Card>
    </div>
  );
};

CaseAlertCard.defaultProps = { svg: '' };

export default CaseAlertCard;
